import http from "../util/http-common";
import {authHeader} from "../util/auth-header";


export class UnreconciledService {
    static async getAllUnreconciledVins(status: string) {
        return http.get(`/cfadminvinadmin/api/v1/unreconciled-vin-pattern/getUnreconciledByStatus?status=${status}`, {headers: await authHeader()});
    }

    static async applyRules(vinPatternId: string) {
        return http.put(`/cfadminvinadmin/api/v1/unreconciled-vin-pattern/applyRule/${vinPatternId}`, null, {headers: await authHeader()});
    }

}

export default UnreconciledService;